<template>
    <div class="d-inline-block">
        <b-btn :disabled="!$store.getters.getCanSign" variant="custom-danger" @click="showModal = true">Отказаться от отправки контракта</b-btn>
        <b-modal v-model="showModal" centered no-close-on-backdrop no-close-on-esc scrollable size="md" title="Отказ от подписания контракта" @close="cancelSendModal" @hide="cancelSendModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <form-row-edit-textarea label="Причина отказа" v-model="comment" :v="$v.comment" :rows="5" label-on-top />
            <h6 class="text-danger fw-600">Обращаем Ваше внимание, что данное действие необратимо.</h6>
            <div slot="modal-footer" class="w-100 px-3">
                <b-button :disabled="isDataSending" variant="custom-outline-secondary" class="mr-2" @click="cancelSendModal">Отмена</b-button>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button variant="custom-danger" @click="sendDecline">Отказаться</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';

export default {
    name: 'fl44-unknown-volume-send-decline-contract-button',
    props: {
        purchaseItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showModal: false,
            isDataSending: false,
            comment: ''
        };
    },
    validations: {
        comment: {
            required,
            minLength: minLength(10)
        }
    },
    methods: {
        cancelSendModal() {
            this.showModal = false;
            this.comment = '';
        },
        async sendDecline() {
            this.isDataSending = true;
            await this.$api.personal.fl44UnknownVolume
                .declineSendContract(this.purchaseItem.id, { comment: this.comment })
                .then((response) => {
                    if (response) {
                        this.cancelSendModal();
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
